function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 63.4582,
  cy: 50,
  fill: "#343a40",
  r: 22
}, React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "2.127659574468085s",
  keyTimes: "0;0.5;1",
  values: "28;72;28",
  begin: "-1.0638297872340425s"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 36.5418,
  cy: 50,
  fill: "#0aa216",
  r: 22
}, React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "2.127659574468085s",
  keyTimes: "0;0.5;1",
  values: "28;72;28",
  begin: "0s"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 63.4582,
  cy: 50,
  fill: "#343a40",
  r: 22
}, React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "2.127659574468085s",
  keyTimes: "0;0.5;1",
  values: "28;72;28",
  begin: "-1.0638297872340425s"
}), React.createElement("animate", {
  attributeName: "fill-opacity",
  values: "0;0;1;1",
  calcMode: "discrete",
  keyTimes: "0;0.499;0.5;1",
  dur: "2.127659574468085s",
  repeatCount: "indefinite"
}));

var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto",
      float: "right"
    },
    width: "60px",
    height: "30px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader.28396a21.svg";
export { ForwardRef as ReactComponent };